(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellary-cookie-banner"]) return;
  try {
    
  (function () {
    function einrichten(wurzel) {
      if (!wurzel || wurzel.getAttribute('data-cc-bereit') === '1') return;
      wurzel.setAttribute('data-cc-bereit', '1');

      var imEditor = wurzel.getAttribute('data-editor') === 'true';

      /* ⚠️ An <body> haengen. Ein z-index wirkt nur im eigenen
         Stapelkontext — in der Fusszeilengruppe waere er eingesperrt und die
         klebende Kopfzeile laege darueber (Fehler aus Runde 41). */
      if (!imEditor && wurzel.parentElement !== document.body) {
        document.body.appendChild(wurzel);
      }

      var leiste = wurzel.querySelector('.bellary-cc__leiste');
      var ebene = wurzel.querySelector('[data-cc-ebene]');
      var panel = wurzel.querySelector('[data-cc-panel]');
      var haken = wurzel.querySelectorAll('[data-cc-kat]');
      var vorherFokus = null;

      /* ---------------- Shopifys Consent-API ---------------- */
      function api() {
        return window.Shopify && window.Shopify.customerPrivacy;
      }

      function apiLaden(fertig) {
        if (api()) { fertig(); return; }
        if (window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
            fertig();
          });
          return;
        }
        fertig();
      }

      /* ⚠️⚠️ RUNDE 43f — WARUM HIER DOCH EIN LOKALER SCHLUESSEL STEHT.
         Live gemessen am 31.8.2026: Nach `setTrackingConsent({alles: true})`
         meldet `shouldShowBanner()` weiterhin true und es wird KEIN
         `_tracking_consent`-Cookie gesetzt. Shopify speichert die
         Entscheidung auf diesem Shop schlicht nicht — derselbe Grund, aus dem
         es auch keinen eigenen Consent-Code ausliefert (vermutlich der
         Passwortschutz).

         Folge ohne Gegenmassnahme: Die Leiste kaeme bei JEDEM Seitenaufruf
         wieder, und das Newsletter-Popup waere dauerhaft gesperrt, weil seine
         Sperre an shouldShowBanner() haengt. Genau das ist Firdaus
         aufgefallen.

         ⚠️ Das hier ist NICHT der rechtliche Nachweis und ersetzt Shopify
         nicht. `setTrackingConsent` wird weiterhin bei jeder Wahl aufgerufen
         und bleibt die Quelle der Wahrheit — nur blockiert Shopifys eigene
         Pixel wirklich. Der lokale Schluessel ist zweierlei:
           1. ein Merker fuer die OBERFLAECHE (Leiste nicht erneut zeigen)
           2. eine Wiedervorlage: beim naechsten Laden wird die gemerkte Wahl
              erneut an setTrackingConsent uebergeben. Sobald Shopify wieder
              speichert (nach dem Launch), kommt sie dort an.
         Faellt der Schluessel weg (privates Fenster, geloeschte Daten), wird
         schlicht erneut gefragt — der sichere Ausgang. */
      var SCHLUESSEL_ANTWORT = 'bellary_cookie_beantwortet';

      function antwortMerken(werte) {
        try {
          window.localStorage.setItem(SCHLUESSEL_ANTWORT, JSON.stringify({ zeit: Date.now(), werte: werte }));
        } catch (e) { /* privates Fenster — dann wird eben erneut gefragt */ }
      }

      function antwortLesen() {
        try { return JSON.parse(window.localStorage.getItem(SCHLUESSEL_ANTWORT) || 'null'); }
        catch (e) { return null; }
      }

      function speichern(werte, danach) {
        var cp = api();
        if (!cp || typeof cp.setTrackingConsent !== 'function') {
          antwortMerken(werte);
          if (danach) danach();
          return;
        }
        antwortMerken(werte);
        try {
          cp.setTrackingConsent(
            {
              analytics: !!werte.analytics,
              marketing: !!werte.marketing,
              preferences: !!werte.preferences,
              sale_of_data: !!werte.marketing
            },
            function () { if (danach) danach(); }
          );
        } catch (e) {
          if (danach) danach();
        }
      }

      function alles(wert) {
        return { analytics: wert, marketing: wert, preferences: wert };
      }

      function ausHaken() {
        var w = { analytics: false, marketing: false, preferences: false };
        for (var i = 0; i < haken.length; i++) {
          w[haken[i].getAttribute('data-cc-kat')] = haken[i].checked;
        }
        return w;
      }

      /* ---------------- Anzeigen und Verstecken ---------------- */
      function leisteZeigen() {
        wurzel.removeAttribute('data-cc-zu');
        wurzel.hidden = false;
      }

      /* ⚠️ RUNDE 43b: Erst hinausfahren, dann verstecken. Zwei Wege, damit es
         nie haengen bleibt — das Animationsende UND ein Zeitgeber. Waehrend
         der Fahrt ist die Leiste `pointer-events: none`, blockiert also
         nichts, falls beides ausbleibt (Hintergrund-Tab, gedrosselte Timer).
         Dasselbe Muster wie beim Newsletter-Popup. */
      function fertigMitAllem() {
        ebeneSchliessen();
        if (wurzel.hidden) return;
        wurzel.setAttribute('data-cc-zu', '');
        var fertig = function () {
          wurzel.removeAttribute('data-cc-zu');
          wurzel.hidden = true;
        };
        var zeitgeber = setTimeout(fertig, 700);
        leiste.addEventListener('animationend', function abschluss(e) {
          if (e.target !== leiste) return;
          leiste.removeEventListener('animationend', abschluss);
          clearTimeout(zeitgeber);
          fertig();
        });
      }

      function ebeneOeffnen() {
        vorherFokus = document.activeElement;
        /* ⚠️⚠️ NIE VORANHAKEN — und das ist kein Selbstlaeufer.
           Shopifys currentVisitorConsent() meldet, solange NICHTS gespeichert
           wurde, fuer alle Kategorien "yes" (live gemessen am 31.8.2026:
           marketing/analytics/preferences alle "yes" ohne jede Einwilligung).
           Wer diesen Wert ungeprueft uebernimmt, haekelt alle Kaestchen vor —
           genau der Verstoss aus EuGH Planet49 (C-673/17).

           shouldShowBanner() ist der verlaessliche Hinweis: Solange es true
           meldet, liegt KEINE Entscheidung vor. Dann bleiben die Kaestchen
           leer, egal was currentVisitorConsent() behauptet. Erst wenn wirklich
           schon entschieden wurde, wird der Stand angezeigt — damit die
           Besucherin ihre eigene Wahl wiederfindet. */
        var cp = api();
        var schonEntschieden = true;
        try {
          if (cp && typeof cp.shouldShowBanner === 'function') schonEntschieden = !cp.shouldShowBanner();
        } catch (e) { schonEntschieden = false; }

        for (var i = 0; i < haken.length; i++) haken[i].checked = false;

        if (schonEntschieden && cp && typeof cp.currentVisitorConsent === 'function') {
          try {
            var c = cp.currentVisitorConsent();
            for (var j = 0; j < haken.length; j++) {
              var k = haken[j].getAttribute('data-cc-kat');
              haken[j].checked = !!(c && c[k] === 'yes');
            }
          } catch (e) { /* dann bleiben sie leer */ }
        }
        wurzel.hidden = false;
        ebene.hidden = false;
        document.addEventListener('keydown', beiTaste, true);
        ebene.addEventListener('click', beiKlickDaneben);
        var erstes = ebene.querySelector('button, input:not([disabled])');
        if (erstes) erstes.focus();
      }

      function ebeneSchliessen() {
        if (ebene.hidden) return;
        ebene.hidden = true;
        document.removeEventListener('keydown', beiTaste, true);
        ebene.removeEventListener('click', beiKlickDaneben);
        if (vorherFokus && typeof vorherFokus.focus === 'function') vorherFokus.focus();
      }

      function beiKlickDaneben(e) { if (e.target === ebene) ebeneSchliessen(); }

      /* Fokusfalle — Ersatz fuer das, was ein natives Modal von selbst taete.
         <dialog> ist hier bewusst nicht im Einsatz, siehe Dateikopf. */
      function beiTaste(e) {
        if (e.key === 'Escape') { e.preventDefault(); ebeneSchliessen(); return; }
        if (e.key !== 'Tab') return;
        var alle = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
        var sichtbare = [];
        for (var i = 0; i < alle.length; i++) {
          if (alle[i].offsetWidth > 0 || alle[i].offsetHeight > 0) sichtbare.push(alle[i]);
        }
        if (!sichtbare.length) return;
        var erste = sichtbare[0], letzte = sichtbare[sichtbare.length - 1];
        if (e.shiftKey && document.activeElement === erste) { e.preventDefault(); letzte.focus(); }
        else if (!e.shiftKey && document.activeElement === letzte) { e.preventDefault(); erste.focus(); }
      }

      /* ---------------- Knoepfe ---------------- */
      function binde(auswahl, tuwas) {
        var el = wurzel.querySelectorAll(auswahl);
        for (var i = 0; i < el.length; i++) el[i].addEventListener('click', tuwas);
      }

      binde('[data-cc-einstellungen]', function () { ebeneOeffnen(); });
      binde('[data-cc-ebene-zu]', function () { ebeneSchliessen(); });
      binde('[data-cc-annehmen]', function () { speichern(alles(true), fertigMitAllem); });
      binde('[data-cc-speichern]', function () { speichern(ausHaken(), fertigMitAllem); });

      /* ⚠️ Ablehnen UND das Kreuz speichern dasselbe: alles aus. "Schliessen
         = akzeptiert" waere ein Abmahngrund. */
      binde('[data-cc-ablehnen]', function () { speichern(alles(false), fertigMitAllem); });
      binde('[data-cc-x]', function () { speichern(alles(false), fertigMitAllem); });

      /* ---------------- Fusszeilen-Link ----------------
         Das Menue "Rechtliches" enthaelt bereits
         "/policies/#shopifyReshowConsentBanner" — Shopifys Anker. Da Shopifys
         eigene Leiste ausgeblendet ist, faengt der Lauscher den Klick ab und
         oeffnet stattdessen unsere Ebene. */
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href*="shopifyReshowConsentBanner"]') : null;
        if (!a) return;
        e.preventDefault();
        ebeneOeffnen();
      });

      if (imEditor) {
        document.addEventListener('shopify:section:select', function (e) {
          if (e.target && e.target.contains(wurzel)) leisteZeigen();
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (e.target && e.target.contains(wurzel)) { wurzel.hidden = true; }
        });
        return;
      }

      /* ---------------- Erstanzeige ----------------
         Shopify entscheidet, ob gefragt werden muss: shouldShowBanner() ist
         true, solange fuer die Region eine Einwilligung noetig und noch keine
         gespeichert ist. Kein eigener Zaehler, kein eigener Speicher. */
      apiLaden(function () {
        var cp = api();
        var gemerkt = antwortLesen();

        /* Wiedervorlage: Die gemerkte Wahl erneut an Shopify geben. Sobald
           deren Speicherung wieder funktioniert, kommt sie dort an — ohne
           dass die Besucherin ein zweites Mal gefragt wird. */
        if (gemerkt && gemerkt.werte && cp && typeof cp.setTrackingConsent === 'function') {
          try {
            cp.setTrackingConsent({
              analytics: !!gemerkt.werte.analytics,
              marketing: !!gemerkt.werte.marketing,
              preferences: !!gemerkt.werte.preferences,
              sale_of_data: !!gemerkt.werte.marketing
            }, function () {});
          } catch (e) { /* egal */ }
        }

        if (gemerkt) return;
        if (!cp || typeof cp.shouldShowBanner !== 'function') return;
        try {
          if (cp.shouldShowBanner()) leisteZeigen();
        } catch (e) { /* API nicht bereit — dann lieber nichts zeigen */ }
      });
    }

    function start() {
      var alle = document.querySelectorAll('[data-bellary-cc]');
      for (var i = 0; i < alle.length; i++) einrichten(alle[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellary-cross-sell-sektion"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Selbst-Nachladen auf /cart ---------- */
  (function () {
    var laeuft = false;

    function neuLaden() {
      var wurzel = document.querySelector('[data-bellary-cs-sektion]');
      if (!wurzel || laeuft) return;
      laeuft = true;
      var ziel = window.location.pathname + '?section_id=' + encodeURIComponent(wurzel.dataset.sektion);
      fetch(ziel, { headers: { Accept: 'text/html' } })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var frisch = new DOMParser().parseFromString(html, 'text/html').querySelector(
            '[data-bellary-cs-sektion]'
          );
          /* ⚠️ Leerer Inhalt ist ein GUELTIGES Ergebnis: sind alle Vorschlaege
             aufgebraucht, rendert das Snippet nichts, und dann soll hier auch
             nichts stehen bleiben. */
          wurzel.innerHTML = frisch ? frisch.innerHTML : '';
        })
        .catch(function () {
          /* Netzfehler: alter Stand bleibt stehen. Schlimmster Fall ist ein
             Vorschlag, der schon im Warenkorb liegt — kein kaputter Zustand. */
        })
        .then(function () {
          laeuft = false;
        });
    }

    document.addEventListener('shopify:cart:lines-update', function (e) {
      /* Das Ereignis wird VOR dem fetch ausgeloest und traegt ein Versprechen,
         das erst nach der Antwort aufloest — sonst laedt man den alten Stand. */
      var fertig = e && e.promise ? e.promise : Promise.resolve();
      fertig.then(neuLaden).catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellary-instagram-band"] && !Shopify.designMode) return;
  try {
    
  /* Bellary — Dauer des Instagram-Laufbands.

     CSS kennt die Spurbreite nicht. Damit das Band bei 6 wie bei 12 Bildern
     gleich schnell laeuft, wird die Dauer einmal aus der gemessenen Breite
     gerechnet:  Dauer = (halbe Spurbreite) / Tempo.

     ⚠️ Die halbe Spurbreite ist hier EXAKT eine Kopie samt ihrem Abstand,
     weil der Abstand als margin-inline-end an jeder Kachel haengt und nicht
     als gap zwischen ihnen. Siehe die Rechnung im Kommentarkopf der Sektion.

     ⚠️ Gemessen wird die LAYOUT-Breite, nicht getBoundingClientRect: das
     Rechteck waere durch die laufende transform verschoben. offsetWidth ist
     transform-frei. */
  (function () {
    var ENTPRELLUNG = 200;

    function dauerSetzen(band) {
      var spur = band.querySelector('[data-bellary-ig-spur]');
      if (!spur) return;
      var tempo = parseFloat(getComputedStyle(band).getPropertyValue('--ig-tempo')) || 40;
      var halbe = spur.offsetWidth / 2;
      if (!halbe) return;
      band.style.setProperty('--ig-dauer', (halbe / tempo).toFixed(2) + 's');
    }

    /* ⚠️ RUNDE 40: Die Kopien laden nicht von selbst.

       `loading="lazy"` entscheidet anhand des SCROLL-Viewports. Die zweite
       Haelfte der Spur steht aber waagerecht weit ausserhalb und wandert nur
       durch eine `transform` ins Bild — Transformationen loesen die
       Lazy-Pruefung nicht neu aus. Auf iOS Safari blieb dadurch eine Kachel
       als kaputtes Bild stehen (von Firdaus gemeldet, 29.8.2026); alle 14
       URLs liefern 200, es war also kein fehlendes Bild.

       Loesung ohne Ladezeitkosten: Solange die Sektion ausserhalb des Bildes
       ist, bleibt alles `lazy` — kein einziges Byte. Sobald sie sichtbar
       wird, wird das Attribut entfernt und der Browser holt alle 14 sofort.
       Die Kopien tragen dieselben URLs wie die Originale und kommen deshalb
       aus dem Zwischenspeicher. */
    function bilderFreigeben(band) {
      [].slice.call(band.querySelectorAll('img[loading="lazy"]')).forEach(function (bild) {
        bild.removeAttribute('loading');
      });
    }

    function beobachten(band) {
      if (!('IntersectionObserver' in window)) {
        bilderFreigeben(band);
        return;
      }
      var beobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (e) {
            if (e.isIntersecting) {
              band.removeAttribute('data-ausser-sicht');
              bilderFreigeben(band);
            } else {
              band.setAttribute('data-ausser-sicht', '');
            }
          });
        },
        { rootMargin: '400px' }
      );
      beobachter.observe(band);
    }

    function aufsetzen(wurzel) {
      var baender = (wurzel || document).querySelectorAll('[data-bellary-ig-band]');
      [].slice.call(baender).forEach(function (band) {
        dauerSetzen(band);
        beobachten(band);
        /* Falls ein Bild doch spaeter Layout aendert: einmal nachfassen. */
        if (band.querySelector('img')) {
          window.setTimeout(function () {
            dauerSetzen(band);
          }, 600);
        }
      });
    }

    var zeitgeber = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(zeitgeber);
      zeitgeber = window.setTimeout(function () {
        aufsetzen(document);
      }, ENTPRELLUNG);
    });

    /* Der Theme-Editor baut Sektionen neu auf, ohne die Seite zu laden. */
    document.addEventListener('shopify:section:load', function (e) {
      aufsetzen(e.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        aufsetzen(document);
      });
    } else {
      aufsetzen(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellary-newsletter-popup"]) return;
  try {
    
  (function () {
    var SCHLUESSEL_ZULETZT = 'bellary_newsletter_popup_zuletzt';
    var SCHLUESSEL_LASCHE = 'bellary_newsletter_lasche_zu';
    var SCHLUESSEL_ANGEMELDET = 'bellary_newsletter_angemeldet';
    var TAG_MS = 86400000;

    /* Untergrenzen gegen den Sofort-Auslöser, siehe Dateikopf. */
    var MIN_SCROLLBAR = 1200;
    var MIN_WEG = 600;

    function lesen(k) {
      try { return window.localStorage.getItem(k); } catch (e) { return null; }
    }
    function schreiben(k, v) {
      try { window.localStorage.setItem(k, v); } catch (e) { /* privates Fenster */ }
    }

    /* ⚠️⚠️ RUNDE 43f — DIE SPERRE HAENGT NICHT MEHR AN shouldShowBanner().
       Genau das hatte das Popup dauerhaft blockiert: Firdaus akzeptierte die
       Cookies, scrollte, und es kam nichts mehr.

       Live gemessen am 31.8.2026 auf bellary.shop:
         vorher    shouldShowBanner true    _tracking_consent-Cookie  nein
         setTrackingConsent({ alles: true }) ...
         nachher   shouldShowBanner true    _tracking_consent-Cookie  nein

       Shopify speichert die Entscheidung auf diesem Shop nicht — derselbe
       Grund, aus dem es auch keinen eigenen Consent-Code ausliefert
       (vermutlich der Passwortschutz). shouldShowBanner() bleibt damit ewig
       true, und eine Sperre daran ist nie erfuellbar.

       Die Anforderung lautet: die beiden Overlays duerfen nie gleichzeitig
       offen sein. Dafuer ist die richtige Frage nicht, was Shopify ueber den
       Consent-Stand behauptet, sondern ob gerade wirklich ein
       Einwilligungsfenster auf dem Schirm steht. Genau das wird jetzt
       geprueft — und das gilt unveraendert weiter, sobald Shopify wieder
       speichert: dann verschwindet die Leiste nach der Wahl, und das Popup
       ist frei. */
    function consentGeklaert() {
      try {
        var ccLeiste = document.querySelector('[data-bellary-cc]');
        if (ccLeiste && !ccLeiste.hidden) return false;
        if (document.querySelector('[data-cc-ebene]:not([hidden])')) return false;
        if (document.querySelector('[id^="shopify-pc"]')) return false;
      } catch (e) { /* im Zweifel nicht blockieren */ }
      return true;
    }

    /* ⚠️ Der scrollbare Vorfahr ist nicht ueberall derselbe: auf dem Desktop
       scrollt .page-wrapper, auf Mobil das Fenster. Beide messen und den
       groesseren Fortschritt nehmen. */
    function scrollMass() {
      var kandidaten = [document.scrollingElement || document.documentElement];
      var pw = document.querySelector('.page-wrapper');
      if (pw) kandidaten.push(pw);
      var best = { max: 0, oben: 0, anteil: 0 };
      for (var i = 0; i < kandidaten.length; i++) {
        var el = kandidaten[i];
        if (!el) continue;
        var max = el.scrollHeight - el.clientHeight;
        if (max <= 0) continue;
        var anteil = el.scrollTop / max;
        if (anteil >= best.anteil) best = { max: max, oben: el.scrollTop, anteil: anteil };
      }
      return best;
    }

    function einrichten(wurzel) {
      if (!wurzel || wurzel.getAttribute('data-np-bereit') === '1') return;
      wurzel.setAttribute('data-np-bereit', '1');

      var imEditor = wurzel.getAttribute('data-editor') === 'true';

      /* ⚠️⚠️ AN <body> HAENGEN — nicht kosmetisch, sondern der Grund, warum das
         Popup vorher unter der Kopfzeile lag. Die Sektion sitzt in der
         Fusszeilengruppe, tief in .page-wrapper. Ein z-index wirkt IMMER NUR
         innerhalb seines Stapelkontexts: Liegt irgendein Vorfahre in einem
         eigenen, ist auch 2147483000 dort gefangen und die klebende Kopfzeile
         bleibt darueber. Mit CSS allein nicht loesbar, weil man den Vorfahren
         nicht kennt. An <body> gibt es keinen fremden Kontext mehr.
         ⚠️ Im Theme-Editor NICHT umhaengen, sonst findet der Editor die
         Sektion beim Auswaehlen nicht mehr. */
      if (!imEditor && wurzel.parentElement !== document.body) {
        document.body.appendChild(wurzel);
      }

      var tiefeSoll = (parseFloat(wurzel.getAttribute('data-scrolltiefe')) || 40) / 100;
      var ruheTage = parseFloat(wurzel.getAttribute('data-ruhe-tage')) || 30;

      var panel = wurzel.querySelector('[data-np-panel]');
      var eingabe = wurzel.querySelector('[data-bellary-np-eingabe]');
      var erfolg = wurzel.querySelector('[data-bellary-np-erfolg]');
      var meldung = wurzel.querySelector('[data-bellary-np-meldung]');
      var form = wurzel.querySelector('form');
      var feld = wurzel.querySelector('input[type="email"]');
      var knopf = wurzel.querySelector('.bellary-np__knopf');
      var zuKnopf = wurzel.querySelector('[data-np-schliessen]');

      /* ⚠️ Die Lasche ist ein Geschwister der Buehne, nicht ihr Kind — sonst
         wuerde sie mit `hidden` verschwinden. Sie wird genauso an <body>
         gehaengt, aus demselben Grund (Stapelkontext der Fusszeile). */
      var lasche = null;
      var laschenHuelle = wurzel.parentElement;
      if (laschenHuelle) lasche = laschenHuelle.querySelector('[data-np-lasche]');
      if (!lasche) lasche = document.querySelector('[data-np-lasche]');
      if (lasche && !imEditor && lasche.parentElement !== document.body) {
        document.body.appendChild(lasche);
      }

      var angemeldet = false;
      var geoeffnet = false;
      var offen = false;
      var vorherFokus = null;
      var gemerkteHoehe = 0;
      var gemerkteStaende = [];
      var gemerkteInert = [];

      /* ---------- Wiederoeffner ----------
         Sichtbar nur, wenn (a) nicht angemeldet, (b) nicht dauerhaft
         weggeklickt und (c) gerade kein Consent-Fenster offen ist. Punkt (c)
         verhindert, dass sie sich mit dem Cookie-Banner unten links stapelt. */
      function laescheZeigen() {
        if (!lasche) return;
        if (angemeldet || lesen(SCHLUESSEL_ANGEMELDET)) return;
        if (lesen(SCHLUESSEL_LASCHE)) return;
        if (!consentGeklaert()) return;
        lasche.hidden = false;
      }

      function laescheVerbergen() {
        if (lasche) lasche.hidden = true;
      }

      /* Solange der Cookie-Banner noch steht, ist (c) nicht erfuellt. Statt
         die Lasche dann fuer immer zu verschlucken, wird eine Minute lang
         nachgesehen — ein Intervall, kein Dauerlaeufer. */
      function laescheNachreichen() {
        laescheZeigen();
        if (!lasche || !lasche.hidden) return;
        var takt = setInterval(function () {
          laescheZeigen();
          if (!lasche.hidden) clearInterval(takt);
        }, 1000);
        setTimeout(function () { clearInterval(takt); }, 60000);
        document.addEventListener('visitorConsentCollected', laescheZeigen);
      }

      if (lasche) {
        var laAuf = lasche.querySelector('[data-np-lasche-auf]');
        var laZu = lasche.querySelector('[data-np-lasche-zu]');
        if (laAuf) laAuf.addEventListener('click', function () { oeffnen(); });
        if (laZu) {
          laZu.addEventListener('click', function () {
            laescheVerbergen();
            if (!imEditor) schreiben(SCHLUESSEL_LASCHE, '1');
          });
        }
      }

      /* ---------- Scrollsperre ----------
         ⚠️ Zwei Wege zusammen. html[scroll-lock] ist Horizons eigene Regel aus
         base.css und deckt den Desktop ab, wo .page-wrapper scrollt. Auf iOS
         reicht `overflow: hidden` allein nicht — dort haelt nur ein fixiertes
         <body> mit gemerktem Versatz. Der Versatz muss beim Schliessen exakt
         zurueckgegeben werden, sonst springt die Seite an den Anfang.
         ⚠️ Das fixierte <body> nur setzen, wenn das FENSTER der Scroller ist.
         Auf dem Desktop scrollt .page-wrapper; dort wuerde es nur Unruhe in
         das Layout bringen. */
      function fensterScrollt() {
        var el = document.scrollingElement || document.documentElement;
        return el.scrollHeight - el.clientHeight > 0;
      }

      /* ⚠️⚠️ GEMESSEN, 31.8.2026: Auf dem Desktop scrollt das FENSTER GAR NICHT
         (scrollHeight − clientHeight = 0), sondern .page-wrapper (3461 px).
         `gemerkteHoehe` las nur das Fenster — fuer den echten Scroller wurde
         also nie etwas gemerkt und nie etwas zurueckgegeben. Deshalb jetzt
         beide Kandidaten, genau die aus scrollMass(). */
      function scrollKandidaten() {
        var raus = [document.scrollingElement || document.documentElement];
        var p = document.querySelector('.page-wrapper');
        if (p) raus.push(p);
        return raus;
      }

      function staendeMerken() {
        gemerkteStaende = [];
        var k = scrollKandidaten();
        for (var i = 0; i < k.length; i++) gemerkteStaende.push([k[i], k[i].scrollTop]);
      }

      function staendeZurueck() {
        for (var i = 0; i < gemerkteStaende.length; i++) {
          var el = gemerkteStaende[i][0], soll = gemerkteStaende[i][1];
          if (el.scrollTop !== soll) el.scrollTop = soll;
        }
      }

      function sperren() {
        staendeMerken();
        gemerkteHoehe = window.pageYOffset || (document.scrollingElement || document.documentElement).scrollTop || 0;
        document.documentElement.setAttribute('scroll-lock', '');
        if (fensterScrollt()) {
          var b = document.body;
          b.style.position = 'fixed';
          b.style.top = (-gemerkteHoehe) + 'px';
          b.style.left = '0';
          b.style.right = '0';
          b.style.width = '100%';
        }
      }

      function entsperren() {
        var b = document.body;
        b.style.position = '';
        b.style.top = '';
        b.style.left = '';
        b.style.right = '';
        b.style.width = '';
        document.documentElement.removeAttribute('scroll-lock');
        window.scrollTo(0, gemerkteHoehe);
        staendeZurueck();
      }

      /* ---------- Hintergrund stilllegen ----------
         Ersatz fuer das, was showModal() von selbst tut. `inert` wird nicht
         ueberall unterstuetzt — die Fokusfalle unten traegt es auch ohne. */
      function inertAn() {
        gemerkteInert = [];
        var kinder = document.body.children;
        for (var i = 0; i < kinder.length; i++) {
          var k = kinder[i];
          if (k === wurzel || k.tagName === 'SCRIPT' || k.tagName === 'STYLE') continue;
          if ('inert' in k) { gemerkteInert.push([k, k.inert]); k.inert = true; }
        }
      }
      function inertAus() {
        for (var i = 0; i < gemerkteInert.length; i++) gemerkteInert[i][0].inert = gemerkteInert[i][1];
        gemerkteInert = [];
      }

      /* ---------- Fokusfalle ---------- */
      function fokusElemente() {
        var alle = wurzel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        var raus = [];
        for (var i = 0; i < alle.length; i++) {
          var e = alle[i];
          if (e.offsetWidth > 0 || e.offsetHeight > 0 || e === document.activeElement) raus.push(e);
        }
        return raus;
      }

      function beiTaste(e) {
        if (e.key === 'Escape') { e.preventDefault(); schliessen(); return; }
        if (e.key !== 'Tab') return;
        var el = fokusElemente();
        if (!el.length) return;
        var erste = el[0], letzte = el[el.length - 1];
        if (e.shiftKey && document.activeElement === erste) { e.preventDefault(); letzte.focus(); }
        else if (!e.shiftKey && document.activeElement === letzte) { e.preventDefault(); erste.focus(); }
      }

      function beiKlick(e) {
        if (e.target === wurzel) schliessen();
      }

      /* ⚠️ Ein geschlossenes Popup ist `display: none`. Bilder mit
         loading="lazy" darin laedt der Browser NICHT — er beginnt erst, wenn
         es sichtbar wird, und dann sieht man beim Oeffnen eine leere Flaeche.
         Genau das war auf dem Handy zu sehen. Deshalb vorher freigeben; lazy
         bleibt im Markup, wer das Popup nie sieht, laedt das Bild nie. */
      function bildFreigeben() {
        var bild = wurzel.querySelector('.bellary-np__foto img');
        if (bild && bild.getAttribute('loading') === 'lazy') bild.removeAttribute('loading');
      }

      function oeffnen() {
        if (offen) return;
        offen = true;
        geoeffnet = true;
        loesen();
        bildFreigeben();
        vorherFokus = document.activeElement;
        sperren();
        wurzel.removeAttribute('data-np-zu');
        wurzel.hidden = false;
        inertAn();
        document.addEventListener('keydown', beiTaste, true);
        wurzel.addEventListener('click', beiKlick);
        if (zuKnopf) {
          try { zuKnopf.focus({ preventScroll: true }); } catch (e) { zuKnopf.focus(); }
        }
        laescheVerbergen();
        diagSchreiben();
      }

      function schliessen() {
        if (!offen) return;
        offen = false;

        /* Alles Funktionale sofort: Lauscher ab, Hintergrund wieder bedienbar,
           Scrollsperre auf, Fokus zurueck. Erst danach das Ausblenden. */
        document.removeEventListener('keydown', beiTaste, true);
        wurzel.removeEventListener('click', beiKlick);
        inertAus();

        /* ⚠️⚠️ DER EIGENTLICHE SPRUNG ANS SEITENENDE, 31.8.2026.
           Der Schliessen-Knopf behielt den Fokus, bis die Buehne 600 ms
           spaeter auf `hidden` ging. Ein FOKUSSIERTES Element zu verstecken
           zwingt den Browser, den Fokus neu zu vergeben — und dabei scrollt
           er zu der Stelle, an der das Element im DOKUMENT steht. Die Buehne
           haengt an <body>, also hinter der Fusszeile. Genau dorthin sprang
           die Seite. Deshalb: Fokus abgeben, BEVOR etwas versteckt wird. */
        if (document.activeElement && wurzel.contains(document.activeElement)) {
          try { document.activeElement.blur(); } catch (e) { /* egal */ }
        }
        entsperren();
        if (vorherFokus && typeof vorherFokus.focus === 'function') {
          /* preventScroll, weil auch das Zurueckgeben des Fokus scrollen darf. */
          try { vorherFokus.focus({ preventScroll: true }); } catch (e) { vorherFokus.focus(); }
        }
        /* ⚠️ Zweiter Durchgang im naechsten Bild: Safari legt das Layout nach
           dem Loesen des fixierten <body> erst dann neu fest. */
        staendeZurueck();
        if (window.requestAnimationFrame) window.requestAnimationFrame(staendeZurueck);
        if (!imEditor && !angemeldet) schreiben(SCHLUESSEL_ZULETZT, String(Date.now()));
        laescheZeigen();

        /* ⚠️ Das Verstecken wartet auf das Ende der Ausblend-Animation, mit
           Zeitgeber als zweitem Weg. Beides kann in einem Hintergrund-Tab
           ausbleiben — deshalb ist die Buehne waehrenddessen schon
           `pointer-events: none` und die Seite bereits entsperrt. Schlimmster
           Fall ist ein durchsichtiges Overlay, das nichts blockiert, kein
           festhaengendes Popup. */
        wurzel.setAttribute('data-np-zu', '');
        var fertig = function () {
          wurzel.hidden = true;
          wurzel.removeAttribute('data-np-zu');
        };
        var zeitgeber = setTimeout(fertig, 600);
        wurzel.addEventListener('animationend', function abschluss(e) {
          if (e.target !== wurzel) return;
          wurzel.removeEventListener('animationend', abschluss);
          clearTimeout(zeitgeber);
          fertig();
        });
      }

      if (zuKnopf) zuKnopf.addEventListener('click', schliessen);

      /* ------------------------------------------------------------------
         Absenden ohne Reload. Faellt bei jeder Server-Ablehnung auf das
         native Absenden zurueck.
         ------------------------------------------------------------------ */
      if (form && meldung && eingabe && erfolg && window.fetch && window.FormData) {
        var FEHLERTEXT = 'Das hat gerade nicht geklappt. Bitte versuch es noch einmal.';
        var nativerVersuch = false;

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (feld && !feld.checkValidity()) { feld.reportValidity(); return; }
          if (knopf) knopf.disabled = true;
          meldung.classList.remove('bellary-np__meldung--fehler');
          meldung.textContent = '…';

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' }
          })
            .then(function (r) {
              /* ⚠️ NICHT auf r.ok pruefen. Shopify liefert die abgelehnte
                 Anmeldung mit Status 200 samt Fehlerseite zurueck. Der
                 belastbare Nachweis ist die Weiterleitung auf
                 ?customer_posted=true. */
              if (r.redirected && r.url.indexOf('customer_posted=true') !== -1) {
                angemeldet = true;
                schreiben(SCHLUESSEL_ANGEMELDET, '1');
                laescheVerbergen();
                meldung.textContent = '';
                eingabe.hidden = true;
                erfolg.hidden = false;
                erfolg.focus();
                return;
              }
              /* ⚠️ Server hat geantwortet, aber nicht bestaetigt. Zwei Faelle:
                 a) Validierungsfehler, b) SHOPIFYS BOT-PRUEFUNG — eine
                 Testanmeldung ueber diesen Weg kam mit HTTP 400 und einer
                 Challenge-Seite zurueck. Eine Challenge laesst sich hier
                 nicht anzeigen. Deshalb nativ absenden: Die Seite laedt neu
                 und Shopify liefert aus, was es ausliefern will.
                 form.submit() loest den submit-Lauscher nicht erneut aus. */
              nativerVersuch = true;
              form.submit();
            })
            .catch(function () {
              if (nativerVersuch) return;
              meldung.classList.add('bellary-np__meldung--fehler');
              meldung.textContent = FEHLERTEXT;
              if (knopf) knopf.disabled = false;
            });
        });
      }

      /* ---------- Ablesehilfe ---------- */
      function diagSchreiben() {
        if (location.search.indexOf('npdiag=1') === -1) return;
        var box = wurzel.querySelector('[data-np-diag]');
        if (!box) return;
        var m = scrollMass();
        var cs = window.getComputedStyle(wurzel);
        box.textContent = [
          'an <body>            ' + (wurzel.parentElement === document.body ? 'ja' : 'NEIN'),
          'position / z-index   ' + cs.position + ' / ' + cs.zIndex,
          'Schleier             ' + cs.backgroundColor,
          'offen                ' + (offen ? 'ja' : 'nein'),
          'scroll-lock          ' + (document.documentElement.hasAttribute('scroll-lock') ? 'ja' : 'NEIN'),
          'body fixiert         ' + (document.body.style.position === 'fixed' ? 'ja' : 'nein'),
          'Bewegung reduziert   ' + (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'JA — Animation aus!' : 'nein'),
          'Panel-Dauer real     ' + (panel ? window.getComputedStyle(panel).animationDuration + ' / Versatz ' + window.getComputedStyle(panel).animationDelay : '-'),
          'inert unterstuetzt   ' + ('inert' in document.createElement('div') ? 'ja' : 'nein'),
          'svh unterstuetzt     ' + (window.CSS && CSS.supports && CSS.supports('height', '1svh') ? 'ja' : 'NEIN'),
          'scrollbar / gescrollt ' + Math.round(m.max) + ' / ' + Math.round(m.oben) + ' px',
          navigator.userAgent
        ].join('\n');
        box.hidden = false;
      }

      /* ---------- Theme-Editor: nie von selbst ---------- */
      if (imEditor) {
        document.addEventListener('shopify:section:select', function (e) {
          if (e.target && e.target.contains(wurzel)) oeffnen();
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (e.target && e.target.contains(wurzel)) schliessen();
        });
        return;
      }

      /* ---------- Auslöser: ausschliesslich Scrolltiefe ---------- */
      if (location.search.indexOf('npdiag=1') !== -1) { oeffnen(); return; }

      if (lesen(SCHLUESSEL_ANGEMELDET)) return;
      var zuletzt = parseFloat(lesen(SCHLUESSEL_ZULETZT));
      if (zuletzt && Date.now() - zuletzt < ruheTage * TAG_MS) {
        /* ⚠️ Waehrend der Ruhefrist kommt das Popup nicht mehr von selbst —
           aber die Lasche haelt den Weg offen. Das ist der Unterschied zum
           Vorbild: dort ist der Weg nach dem Schliessen sonst zu. */
        laescheNachreichen();
        return;
      }

      var wartet = false;
      var pw = document.querySelector('.page-wrapper');
      var seiteFertig = document.readyState === 'complete';
      if (!seiteFertig) {
        window.addEventListener('load', function () { seiteFertig = true; });
      }

      /* ⚠️⚠️ VIER Bedingungen, nicht eine. Der Prozentwert allein hat das
         Popup auf dem Handy sofort aufspringen lassen, weil das Dokument
         direkt nach dem Laden viel kuerzer ist als am Ende (nachladende
         Bilder). Ein frueher Scroll-Impuls ergab dann 200/400 = 50 %.
         Bedingung 1 wartet auf 'load', 2 und 3 setzen absolute Untergrenzen. */
      function pruefeAusloeser() {
        wartet = false;
        if (offen || geoeffnet) return;
        if (!seiteFertig) return;
        if (!consentGeklaert()) return;
        var m = scrollMass();
        if (m.max < MIN_SCROLLBAR) return;
        if (m.oben < MIN_WEG) return;
        if (m.anteil < tiefeSoll) return;
        oeffnen();
      }

      function beiScroll() {
        if (wartet) return;
        wartet = true;
        if (window.requestAnimationFrame) window.requestAnimationFrame(pruefeAusloeser);
        else setTimeout(pruefeAusloeser, 60);
      }

      function loesen() {
        window.removeEventListener('scroll', beiScroll);
        if (pw) pw.removeEventListener('scroll', beiScroll);
        document.removeEventListener('visitorConsentCollected', beiScroll);
      }

      window.addEventListener('scroll', beiScroll, { passive: true });
      if (pw) pw.addEventListener('scroll', beiScroll, { passive: true });
      document.addEventListener('visitorConsentCollected', beiScroll);
    }

    function start() {
      var alle = document.querySelectorAll('[data-bellary-np]');
      for (var i = 0; i < alle.length; i++) einrichten(alle[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  /* ---------- Bellary: Laufband fuer zu lange Ankuendigungszeilen ----------
     Ob eine Zeile zu lang ist, kann CSS nicht wissen — deshalb hier gemessen
     und nur dann ein Band gebaut. Alles andere bleibt unveraendert stehen. */
  (function () {
    var MOBIL = '(max-width: 749px)';
    var TEMPO = 35;    /* px pro Sekunde — bewusst langsam, Lesetempo */
    var LUECKE = 48;   /* Abstand zwischen Original und Kopie */

    function original(p) {
      if (!p.hasAttribute('data-tick-quelle')) {
        p.setAttribute('data-tick-quelle', p.innerHTML);
      }
      return p.getAttribute('data-tick-quelle');
    }

    function zuruecksetzen(p) {
      p.classList.remove('bellary-tick--laeuft');
      p.style.removeProperty('--bellary-tick-dauer');
      p.style.removeProperty('--bellary-tick-luecke');
      p.innerHTML = original(p);
    }

    function pruefe(p) {
      zuruecksetzen(p);
      if (!window.matchMedia || !window.matchMedia(MOBIL).matches) return;

      /* Erst in ein Stueck fassen und messen. Passt es, bleibt es so. */
      var band = document.createElement('span');
      band.className = 'bellary-tick__band';
      var stueck = document.createElement('span');
      stueck.className = 'bellary-tick__stueck';
      stueck.innerHTML = original(p);
      band.appendChild(stueck);
      p.innerHTML = '';
      p.appendChild(band);

      var platz = p.clientWidth;
      var noetig = stueck.getBoundingClientRect().width;
      if (!platz || noetig <= platz + 1) {
        zuruecksetzen(p);
        return;
      }

      /* ⚠️ Die Kopie ist fuer Screenreader unsichtbar — sonst liest die
         Leiste (aria-live) jede Ansage doppelt vor. */
      var kopie = stueck.cloneNode(true);
      kopie.setAttribute('aria-hidden', 'true');
      band.appendChild(kopie);

      p.style.setProperty('--bellary-tick-luecke', LUECKE + 'px');
      p.style.setProperty('--bellary-tick-dauer', ((noetig + LUECKE) / TEMPO).toFixed(2) + 's');
      p.classList.add('bellary-tick--laeuft');
    }

    function alle() {
      var zeilen = document.querySelectorAll('.announcement-bar__text');
      for (var i = 0; i < zeilen.length; i++) pruefe(zeilen[i]);
    }

    var wartet;
    function spaeter() {
      clearTimeout(wartet);
      wartet = setTimeout(alle, 200);
    }

    function start() {
      alle();
      /* ⚠️ Nach dem Laden der Schrift noch einmal: vorher misst der Browser
         die Ersatzschrift, und die ist anders breit. */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(alle);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    window.addEventListener('resize', spaeter);
    window.addEventListener('orientationchange', spaeter);
    document.addEventListener('shopify:section:load', spaeter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
